"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const MUTEZ_DIGITS = 6;
const SHARD_DIGITS = 18;
const MUTEZ_TO_SHARD = new bignumber_js_1.default(Math.pow(10, SHARD_DIGITS - MUTEZ_DIGITS));
const SHARD_PRECISION = new bignumber_js_1.default(Math.pow(10, SHARD_DIGITS));
const ConversionUtils = {
    mutezToShard: (mutez) => {
        return mutez.times(MUTEZ_TO_SHARD);
    },
    shardToHumanReadablePercentage: (shard, precision) => {
        const percentageShard = shard.times(100);
        const humanReadable = ConversionUtils.shardToHumanReadableNumber(percentageShard, precision);
        return `${humanReadable}%`;
    },
    shardToHumanReadableNumber: (shard, precision) => {
        const humanReadable = shard.dividedBy(SHARD_PRECISION);
        if (precision === undefined) {
            return humanReadable.toString();
        }
        else {
            return humanReadable.toFixed(precision);
        }
    },
};
exports.default = ConversionUtils;
//# sourceMappingURL=conversion-utils.js.map